import {
  BaseQueryFn,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react"
import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions"
import {
  RootState,
  dynamicMiddlewaresInstance,
  registerReducer,
} from "@core/store"
import { baseQueryWithReauth } from "@/modules/app/store"
import { TG, TgMailing, TgMailingUsers } from "../interfaces"

const tagTypes = ["Users"] as const

const reducerPath: string = "telegramAdvApi"
export const baseTgAdvApiURL = new URL(
  import.meta.env.REACT_APP_ADV_API,
  window.location.origin,
).toString()
export const baseTelegramAdvUrl = `${
  baseTgAdvApiURL.endsWith("/") ? baseTgAdvApiURL : baseTgAdvApiURL + "/"
}`
const baseQuery: BaseQueryFn = fetchBaseQuery({
  baseUrl: baseTelegramAdvUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token
    if (token) {
      headers.set("authorization", `Bearer ${token}`)
    }
    return headers
  },
})

type ApiEndpointBuider = EndpointBuilder<
  typeof baseQuery,
  (typeof tagTypes)[number],
  typeof reducerPath
>

const endpoints = (build: ApiEndpointBuider) => ({
  users: build.query<TgMailingUsers.UsersRes, TgMailingUsers.UsersReq>({
    query: ({ queryParams }) => ({
      url: `push/users`,
      method: "GET",
      params:
        queryParams &&
        Object.entries(queryParams)
          .filter(([key, value]) =>
            Array.isArray(value)
              ? !!value.length
              : value !== null && value !== undefined,
          )
          .map(([key, value]) =>
            Array.isArray(value)
              ? value.map((v) => `${key}=${v}`).join("&")
              : `${key}=${value}`,
          )
          .join("&"),
    }),
    providesTags: ["Users"],
  }),
})

export const telegramAdvApi = createApi({
  reducerPath,
  tagTypes,
  baseQuery: baseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    ...endpoints(build),
  }),
})
dynamicMiddlewaresInstance.addMiddleware(telegramAdvApi.middleware)
registerReducer(telegramAdvApi.reducerPath, telegramAdvApi.reducer)

export const { useUsersQuery } = telegramAdvApi
